//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	export default {
		data() {
			return {}
		},
		model: {
			prop: 'isShow',
			event: 'change'
		},
		props: {
			isShow: {
				type: Boolean,
				default: false
			},
			title: {
				type: String,
				default: '提示'
			},
			theme:{
				type: String,
			},
			content: {
				default: '是否删除此内容？'
			},
			width: {
				type:[Number,String]
			},
			confirmText: {
				type: String,
				default: '确定'
			},
			cancelText: {
				type: String,
				default: '取消'
			},
		},
		watch: {
			isShow(val) {
				this.$emit(val ? 'onShow' : 'onHide')
			}
		},
		mounted() {
			this.isShow && this.$emit('onShow')
		},
		methods: {
			_onHide() {
				this.$emit('change', false)
			},
			_onConfirm() {
				this.$emit('change', false)
			},
			_onCancel() {
				this.$emit('change', false)
			}
		}
	}




// WEBPACK FOOTER //
// ./src/components/alertPlugin/confirm.vue